// the screens a customer creates an account on, each recorded as the source of the marketing consent the account
// carries from creation - CommunicationPreferenceSources keys
export const ACCOUNT_CONSENT_SOURCES = {
	FUNNEL: 'READYRX_FUNNEL',
	SIGN_UP: 'READYRX_ACCOUNT',
	SUPPORT: 'READYRX_SUPPORT'
};

// an account staff create in admin signs no agreement the consent could be dated from, so staff are its source
export const STAFF_CREATED_CONSENT_SOURCE = 'READYRX_ADMIN';
